import React from "react";
import './board.css';
import Square from "./Square";
import Node from './Node';


class Board extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
          status: "",
          grid:[]
        };

        this.files = 20;
        this.columnes = 20;

        let Heap = require("collections/heap");
        this.open = new Heap(null, null, this.compareNodes);
        this.closed = [];
        this.initialNode = this.props.initialNode;
        this.finalNode= this.props.finalNode;
    }

    compareNodes = (a,b) => {
        if (a.getF() < b.getF()) {
            return 1;
        } else if (a.getF() > b.getF()) {
            return -1;
        }

        if (a.h === b.h) {
            return 0;
        }

        if (a.h < b.h) {
            return 1;
        } else {
            return -1;
        }
    }

    createWall(i,j) {
        document.getElementById(`${i}-${j}`).className = 'square square_wall';
        let newGrid = this.state.grid.slice();
        newGrid[i][j] = <Square key={i+","+j} position = {{x:i, y:j}} wall/>
        this.setState({
            grid: newGrid
        })
    }

    createBoard = () => {
        this.grid = [];
        for (let i = 0; i < this.files; i++) {
            this.grid.push([]);
            for (let j = 0; j < this.columnes; j++) {
                let pos = {x: i, y: j};
                this.grid[i].push(<Square key={i+","+j} position = {pos} handleClick={ () => this.createWall(i,j)}/>);
            }
        }
        
        this.grid[this.initialNode.x][this.initialNode.y] = <Square key={this.initialNode.x+","+this.initialNode.y} position = {this.initialNode} start/>;
        this.grid[this.finalNode.x][this.finalNode.y] = <Square key={this.finalNode.x+","+this.finalNode.y} position={this.finalNode} final/> 
        
        this.setState({
            grid: this.grid
        })
        return this.state.grid;
    }

    plotPath() {
        document.getElementById("startButton").disabled = true;
        let [nodes, path] = this.calculaCasella(this.initialNode, this.finalNode);

        for (let i = 1; i < nodes.length - 1; i++) {
            setTimeout( () => {
                const node = nodes[i];
                document.getElementById(`${node.x}-${node.y}`).className = 'square square_closed';

                if (i === nodes.length - 2) {
                    this.plotSolution(path);
                }
            }, i * 15);
        }
    }

    plotSolution(path) {
        for (let i = 0; i < path.length; i++) {
            setTimeout( () => {
                const node = path[i];
                document.getElementById(`${node.x}-${node.y}`).className = 'square square_solution';
            }, 30 * i)
        }
    }

    calculaCasella(initialNode, finalNode) {
        let visitedNodes = [];
        let path = [];
        initialNode.g = 0;
        initialNode.calcularHeuristica(this.finalNode); // node final
        this.open.push(initialNode);

        while (this.open.length > 0) {
            let current = this.open.pop();
            this.closed.push(current);
            this.plotClosed(current);
            visitedNodes.push(current);
            
            if (current.isSameNode(finalNode)) {              
                path = this.buildPath(current, initialNode);
                return [visitedNodes, path];
            }
            this.generateNeighbours(current);
        }

        this.grid[this.initialNode.x][this.initialNode.y] = <Square key={this.initialNode.x+","+this.initialNode.y} position = {this.initialNode} start/>;
        this.grid[this.finalNode.x][this.finalNode.y] = <Square key={this.finalNode.x+","+this.finalNode.y} position={this.finalNode} final/>
        return [visitedNodes, path];
    }
    
    generateNeighbours = (current) => {

        let neighbours = current.getNeighbours(this.grid);
        neighbours.forEach(neighbour => {
            neighbour.prev = current;
            neighbour.g = current.g + 1;
            neighbour.calcularHeuristica(this.finalNode);

            // check if closed contains
            let index = this.closed.findIndex( (item, index) => {
                if (item.x === neighbour.x && item.y === neighbour.y) {
                    return true;
                }
            });
            if (index !== -1) {
                let node = this.closed[index];

                if (this.compareNodes(neighbour, node) === 1) {
                    this.closed = this.closed.filter(item => item !== node);
                    this.open.add(neighbour);
                }

            } else {
                let i = this.closed.findIndex( (item, index) => {
                    if (item.x === neighbour.x && item.y === neighbour.y) {
                        return true;
                    }
                });

                if (i !== -1) {
                    let n = this.open[i];
                    if (this.compareNodes(neighbour, n) === 1) {
                        this.open.delete(n);
                        this.open.add(neighbour);
                    }
                    
                } else {
                    this.open.add(neighbour);
                }
            }

        });

    }

    plotClosed = (node) => {
        let pos = {x: node.x, y: node.y};
        let closed = this.closed.some( (n) => {
            if (n.x === pos.x && n.y === pos.y) {
                return true;
            }
        } );
        
        this.grid[pos.x][pos.y] = <Square key={pos.x+","+pos.y} position = {pos} closed={closed}/>; 
    }

    buildPath = (current, initial) => {
        let path = [];
        let parent = current;
        while (!parent.prev.isSameNode(initial)) {
            current = parent;        
            parent = current.prev;
            //dibuixar
            path.push(parent);
        }
        return path;
    }

    componentDidMount() {
        this.createBoard();
    }

    refreshPage = () => {
        window.location.reload();
    }

    render() {   
        return (
            <div className="container">
                <div className="board">
                    {this.state.grid}
                </div>
                <div className="section-buttons">
                    <button id="startButton" onClick={() =>{this.plotPath()}}>Find path</button>
                    <button onClick={this.refreshPage}>Refresh</button>
                    <p>Allowed movements are north, east, south, west.</p>
                    <p>If you click on a tile it creates a wall that can't be crossed.</p>
                </div>                
            </div>            
        )
    }
}

export default Board;